import { FunctionComponent } from 'react';
import AddExistingLicenseSystemToOrgModal from './AddExistingLicenseSystemToOrgModal';
import { useParams } from 'react-router-dom';
import { useAssignLicenseSystemToOrg } from 'src/graphql/useAssignLicenseSystemToOrg';
import { toast } from '@gmg/gmg-react-components';
import { useTranslation } from 'react-i18next';

export interface AddExistingLicenseSystemToOrgModalContainerProps {
    onClose?: () => void;
};

const AddExistingLicenseSystemToOrgModalContainer: FunctionComponent<AddExistingLicenseSystemToOrgModalContainerProps> = (props) => {
    const { t } = useTranslation();
    const params = useParams();
    const assignLicenseSystemToOrg = useAssignLicenseSystemToOrg(params.orgId!);

    const handleOnSubmit = (licenseSystemId: string) => {
        void toast.promise(assignLicenseSystemToOrg.mutateAsync(licenseSystemId), {
            loading: t('Common.Toast.Loading', 'Loading ...'),
            success: t('AssignLicenseSystemToOrganization.toast_success_desc', {
                defaultValue: 'You have successfully added license system "{{serialNumber}}" to your organization.',
                serialNumber: licenseSystemId,
            }),
            error: (response) => response.errors[0].message,
        });
    };

    return (
        <AddExistingLicenseSystemToOrgModal
            onClose={props.onClose}
            onSubmit={(licenseSystemId: string) => { handleOnSubmit(licenseSystemId); }}
        />
    );
};

export default AddExistingLicenseSystemToOrgModalContainer;